import logger from 'nandos-dev-logger'
import CustomValidators from '../validation/validators'
import ValidationMessages from '../validation/messages'

export default {

  props: {
    errorMessage: { type: Object },
  },

  data () {
    return {
      nativeInvalid: false, // browser dispatched an "invalid" event from the <input>
      inputLeftDirty: false, // the input was modified, and then lost focus
      first_run: true,
      valid: true,
      errors: [],
      originalValue: this.value,
    }
  },

  mounted() {
    if(!this.$refs.controlEl) logger.error('Nandos Core-UI', 'The validatable mixin requires a control element reference')
    
    this.$refs.controlEl.addEventListener('blur', this.onBlur)
    this.$refs.controlEl.addEventListener('invalid', this.onInvalid)

    this.validate()
  },

  updated() {
    if(this.first_run) { // After the first update, validate the initial value of the input
      this.first_run = false
      this.validate()
    } 
  },

  beforeDestroy () {
    this.$refs.controlEl.removeEventListener('blur', this.onBlur)
    this.$refs.controlEl.removeEventListener('invalid', this.onInvalid)
  },

  watch: {
    value(value) {
      setTimeout(() => this.validate(), 0)
    }
  },

  computed: {    
    validation_classes() {
      return {
        'is-valid': this.valid,
        'has-error': this.show_error,
      }
    },

    show_error() {
      return !this.valid && (this.nativeInvalid || this.inputLeftDirty)
    },
  },

  methods: {

    onBlur(event) {
      let dirty = this.originalValue != this.value
      if(dirty) this.inputLeftDirty = true
      this.validate()
    },

    onInvalid(event) {
      this.nativeInvalid = true
      this.validate()
    },

    validate() {
      if(this._isDestroyed) return
      
      this.errors = []
      let el = this.$refs.controlEl

      // Check if standard HTML rules pass
      if(el.validity.valid === false) {
        let state = el.validity
        for(var prop in state) {
          if(state[prop] === true) {
            this.errors.push( generateError(this, prop) )
          }
        }
      }

      // Check if custom rules pass
      Object.entries(CustomValidators.rules)
        .forEach(([validatorKey, validatorTest]) => {
          let hasMatchingAttr = el.getAttribute(validatorKey) !== null
          if(hasMatchingAttr) {
            let passed = validatorTest(el, el.getAttribute(validatorKey))
            if(passed === false) {
              this.errors.push( generateError(this, validatorKey) )
            }
          }
        })

      this.valid = this.errors.length === 0
    }
  }
}

function generateError(component, errorType) {
  // Handle special 'typeMismatch' error cases
  if(errorType === 'typeMismatch') {
    let type = component.$refs.controlEl.getAttribute('type')
    switch(type) {
      case 'email': return ValidationMessages.getErrorMessage(component, 'emailMismatch'); break
      case 'url': return ValidationMessages.getErrorMessage(component, 'urlMismatch'); break
      case 'number': return ValidationMessages.getErrorMessage(component, 'numberMismatch'); break
    }
  }
  // All other error types
  else {
    return ValidationMessages.getErrorMessage(component, errorType)
  }
}